import { useState } from 'react'
import type { AnalysisMode } from './AnalysisModeCards'
import type { OutputMode } from './OutputOptions'
import type { CompetitorResult } from '@/lib/api/amazon-listing'

export type InputTab = 'asin' | 'keyword' | 'produkt' | 'manuell'

export interface CampaignCreatorState {
  tab: InputTab
  setTab: (t: InputTab) => void
  inputValue: string
  setInputValue: (v: string) => void
  tld: string
  setTld: (t: string) => void
  mode: AnalysisMode
  setMode: (m: AnalysisMode) => void
  output: OutputMode
  setOutput: (o: OutputMode) => void
  customModalOpen: boolean
  setCustomModalOpen: (v: boolean) => void
  confirmedCompetitors: CompetitorResult[]
  setConfirmedCompetitors: (c: CompetitorResult[]) => void
  batchMode: boolean
  setBatchMode: (v: boolean) => void
  asins: string[]
  setAsins: (a: string[]) => void
}

export function useCampaignCreator(initialMode: AnalysisMode = 'standard'): CampaignCreatorState {
  const [tab, setTab] = useState<InputTab>('asin')
  const [inputValue, setInputValue] = useState('')
  const [tld, setTld] = useState('de')
  const [mode, setMode] = useState<AnalysisMode>(initialMode)
  const [output, setOutput] = useState<OutputMode>('audit')
  const [customModalOpen, setCustomModalOpen] = useState(false)
  const [confirmedCompetitors, setConfirmedCompetitors] = useState<CompetitorResult[]>([])
  const [batchMode, setBatchMode] = useState(false)
  const [asins, setAsins] = useState<string[]>([])
  return { tab, setTab, inputValue, setInputValue, tld, setTld, mode, setMode,
           output, setOutput, customModalOpen, setCustomModalOpen,
           confirmedCompetitors, setConfirmedCompetitors,
           batchMode, setBatchMode, asins, setAsins }
}
